import { LoadingController } from 'ionic-angular';
import { CoinsProvider } from './../../providers/coins/coins';
import { Coin } from './../../models/Coin';
import { Component, ViewChild, Input, ElementRef, SimpleChanges } from '@angular/core';
import { CMC } from '../../models/CoinMarketCap'
import * as Highcharts from 'highcharts/highstock';

/**
 * Generated class for the CoinChartsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'coin-charts',
  templateUrl: 'coin-charts.html'
})
export class CoinChartsComponent {
  @Input('coin') coin: Coin;
  @Input('startDate') startDate: string;
  @Input('height') height: number;
  @Input('width') width: number;
  @Input('currency') currency: number;
  @ViewChild('intervalSegment') intervalSegment: ElementRef;

  interval = 'day';
  chartReady: boolean = false;
  Highcharts = Highcharts; // required
  chartConstructor = 'stockChart'; // optional string, defaults to 'chart'

  chartOptions = {
  };
  // chartCallback = function (chart) { ... } // optional function, defaults to null
  updateFlag = false; // optional boolean
  oneToOneFlag = true; // optional boolean, defaults to false

  constructor(public CP: CoinsProvider, public loadingCtrl: LoadingController) {
  }

  ngOnInit() {
    this.initChart();
  }

  ngOnChanges(changes: SimpleChanges){
    if(!changes.currency.isFirstChange()){
      this.initChart();
    }
  }

  changeInterval(){
    this.initChart();
  }

  getCandleSticks(ohlv: CMC.OHLVC[]): number[][] {
    let sticks = [];
    for (let o of ohlv) {
      sticks.push([
        o.time * 1000, //miliseconds vs seconds
        o.open,
        o.high,
        o.low,
        o.close
      ])
    }
    return sticks;
  }

  getVolume(ohlv: CMC.OHLVC[]): number[][] {
    let points = [];
    for (let o of ohlv) {
      points.push([
        o.time * 1000,
        o.volumeto
      ]);
    }
    return points;
  }

  private initChart(){
    let loader = this.loadingCtrl.create();
    loader.present();
    this.CP.getChartData(this.interval, this.coin, this.startDate)
      .subscribe((data: CMC.OHLVC[]) => {
        let candleSticks = this.getCandleSticks(data);
        let volume = this.getVolume(data);
        this.setChart(candleSticks, volume);
        this.updateFlag = true;
        loader.dismiss();
      }, error =>{
        console.log(error);
        loader.dismiss();
      })
  }


  private setChart(candlesticks, volume) {
    let width = this.width;
    let height = this.height - this.intervalSegment.nativeElement.offsetHeight;

    this.chartOptions = {
      chart: {
        height: height,
        width: width,
        backgroundColor: 'transparent',
        plotBorderColor: "#fce4ec"
      },
      // colors: ['#8ADCF9', '#9d1cdb'],
      data: {
        dateFormat: 'mm/dd/YY'
      },
      rangeSelector: {
        enabled: true,
        labelStyle: {
          color: '#ffffff'
        },
        inputEnabled: false,
        buttons: this.getRangeSelectorButtons(this.interval)
      },
      scrollbar: {
        enabled: false
      },
      navigator: {
        enabled: true,
        height: 60,
        handles: {
          width: 10,
          height: 40
        }
      },
      legend: {
        itemStyle: {
          font: '9pt Trebuchet MS, Verdana, sans-serif',
          color: '#A0A0A0'
        },
        itemHoverStyle: {
          color: '#FFF'
        },
        itemHiddenStyle: {
          color: '#444'
        }
      },
      credits: {
        style: {
          color: '#666'
        }
      },
      labels: {
        style: {
          color: '#CCC'
        }
      },
      plotOptions: {
        candlestick: {
          lineColor: 'white',
          upColor: '#46ff46',
          color: '#ff1a1a'
        },
        column: {
          color: '#9d1cdb'
        }
      },
      title: {
        text: null
      },
      subtitle: {
        style: {
          color: '#666666',
          font: 'bold 12px "Trebuchet MS", Verdana, sans-serif'
        }
      },
      tooltip: {
        shared: true,
        hideDelay: 50,
        xDateFormat: '%A, %b %e, %Y'
      },
      xAxis: [
        {
          type: 'datetime',
          dateTimeLabelFormats: {
            millisecond: '%H:%M:%S.%L',
            second: '%H:%M:%S',
            minute: '%H:%M',
            hour: '%H:%M',
            day: '%e. %b',
            week: '%e. %b',
            month: '%b \'%y',
            year: '%Y'
          },
          labels: {
            style: {
              color: '#ffffff'
            }
          },
        }
      ],
      yAxis: [{
        labels: {
          align: 'right',
          // x: -3,
          style: {
            color: '#ffffff'
          }
        },
        title: {
          text: null
        },
        height: '100%',
        lineWidth: 1,
        resize: {
          enabled: true
        },
        // min: 0
      },
      {
        labels: {
          enabled: false
        },
        title: {
          text: null,
        },
        style: {
          color: "transparent"
        },

        showEmpty: false,
        top: '80%',
        height: '20%',
        lineWidth: 0,
        minorGridLineWidth: 0,
        gridLineWidth: 0
      }],
      series: [
        {
          type: "candlestick",
          data: candlesticks,
          name: 'OHLC'
        },
        {
          type: "column",
          name: 'Volume',
          data: volume,
          yAxis: 1
        }
      ],
    }
    this.chartReady = true;
  }


  private getRangeSelectorButtons(interval: string): any{
    let buttons;
    if(interval == 'day'){
      buttons = [{
          type: 'month',
          count: 1,
          text: '1M'
        }, {
          type: 'month',
          count: 3,
          text: '3M'
        }, {
          type: 'month',
          count: 6,
          text: '6M'
        }, {
          type: 'ytd',
          text: 'YTD'
        }, {
          type: 'year',
          count: 1,
          text: '1Y'
        }, {
          type: 'all',
          text: 'All'
        }];
    }else if(interval == 'hour'){
      buttons = [{
          type: 'hour',
          count: 12,
          text: '12h'
        }, {
          type: 'day',
          count: 1,
          text: 'Day'
        }, {
          type: 'week',
          count: 1,
          text: '1W'
        }, {
          type: 'month',
          count: 1,
          text: '1M'
        }, {
          type: 'month',
          count: 2,
          text: '2M'
        }, {
          type: 'all',
          text: 'All'
        }];
    }else{
      buttons = [{
          type: 'minute',
          count: 15,
          text: '15m'
        }, {
          type: 'minute',
          count: 30,
          text: '30m'
        }, {
          type: 'hour',
          count: 1,
          text: '1h'
        }, {
          type: 'hour',
          count: 12,
          text: '12h'
        }, {
          type: 'day',
          count: 1,
          text: 'Day'
        }, {
          type: 'all',
          text: 'All'
        }];
    }
    return buttons;
  }
}



// WEBPACK FOOTER //
// ./src/components/coin-charts/coin-charts.ts